import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Title, useGetList, Loading, Error } from "react-admin";
import MercadoPagoForm from "./MercadoPagoForm";
import AlreadySubscribed from "./AlreadySubscribed";
import SUBSCRIPTION_STATUS from "../enums/SubscriptionStatus";

const Payments = () => {
  const restaurant = JSON.parse(localStorage.getItem("restaurant") || "{}");
  const activeSubscription = restaurant?.subscriptions?.find(
    (s) => s.status === SUBSCRIPTION_STATUS.ACTIVE
  );

  const {
    data: plans,
    isLoading,
    error,
  } = useGetList("restaurant-subscription-plans", {
    pagination: { page: 1, perPage: 100 },
    sort: {},
  });

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <Error />;
  }

  return (
    <Card>
      <Title title="Suscripción" />
      <CardContent>
        {activeSubscription ? (
          <AlreadySubscribed plans={plans} />
        ) : (
          <MercadoPagoForm plans={plans} />
        )}
      </CardContent>
    </Card>
  );
};

export default Payments;
